module.exports = __webpack_public_path__ + "static/media/app-transparency.97f660b1.png";